"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayersFirestore = exports.PlayerFirestore = exports.PlayerModsFirestore = void 0;
class PlayerModsFirestore {
    constructor(root) {
        this.root = root;
        // construct
    }
    gamifiedEducationDoc() {
        return this.root.doc('gamifiedEducation');
    }
    async getGamifiedEducation() {
        const data = await this.gamifiedEducationDoc().get();
        return data.data();
    }
}
exports.PlayerModsFirestore = PlayerModsFirestore;
class PlayerFirestore {
    constructor(root) {
        this.root = root;
        this.mods = new PlayerModsFirestore(this.root.collection('mods'));
        // construct
    }
}
exports.PlayerFirestore = PlayerFirestore;
class PlayersFirestore {
    constructor(root) {
        this.root = root;
        // construct
    }
    player(playerEmail) {
        return new PlayerFirestore(this.root.doc(playerEmail));
    }
}
exports.PlayersFirestore = PlayersFirestore;
